import { Box } from "@chakra-ui/react";
import Header from "./Header/index";
import Footer from "./Footer/index";
import WhatsAppButton from "./WhatsAppButton";
const GA_MEASUREMENT_ID = "G-2PTFPX25ZB";

function loadGAScript() {
  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  const script2 = document.createElement("script");
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_MEASUREMENT_ID}');
  `;
  document.head.appendChild(script2);
}

loadGAScript();
export default function Layout({ children }: any) {
  return (
    <Box minH="100vh" bg={"#FAFAFA"} maxW="100vw">
      <Box justifyContent="space-between">
        <Header />
        <Box>{children}</Box>
        <Footer />
        <WhatsAppButton />
      </Box>
    </Box>
  );
}
